(() => {
  const TARGET_BLOCK_ID = 'block-16321237356a896dad-0';
  const BUTTON_ID = 'homepage-hero-shop-button';
  const STYLE_ID = 'homepage-hero-shop-button-styles';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #${TARGET_BLOCK_ID} { position: relative; }
      #${BUTTON_ID} {
        position: absolute;
        left: 50%;
        bottom: 42px;
        transform: translateX(-50%);
        z-index: 6;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 195px;
        min-height: 44px;
        padding: 12px 24px;
        border: 1px solid #232323;
        background: #232323;
        color: #ffffff;
        text-decoration: none;
        text-align: center;
        font-weight: 600;
        line-height: 1.2;
        transition: background-color .2s ease, color .2s ease, border-color .2s ease;
      }
      #${BUTTON_ID}:hover,
      #${BUTTON_ID}:focus-visible {
        background: #ffffff;
        color: #232323;
        border-color: #232323;
      }
      @media (max-width: 767px) {
        #${BUTTON_ID} {
          bottom: 20px;
          min-width: 150px;
          min-height: 42px;
          padding: 10px 18px;
          font-size: 13px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function addButton() {
    if (window.location.pathname !== '/') return;

    const slide = document.getElementById(TARGET_BLOCK_ID);
    if (!slide || document.getElementById(BUTTON_ID)) return;

    addStyles();

    const button = document.createElement('a');
    button.id = BUTTON_ID;
    button.href = '/collections/all';
    button.textContent = 'SHOP NOW';
    button.setAttribute('aria-label', 'Shop pool tables');
    slide.appendChild(button);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addButton, { once: true });
  } else {
    addButton();
  }

  new MutationObserver(() => {
    if (!document.getElementById(BUTTON_ID)) addButton();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();